module.exports = __webpack_public_path__ + "static/media/User_experience_personas_customers_2_2014.dff70a71.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/User_experience_personas_customers_2_2014.pdf
// module id = 361
// module chunks = 0